import { useQuery } from "@apollo/client";
import { useAuth0 } from "@auth0/auth0-react";
import { constantsData, urlsData } from "data";
import { getMemberQuery } from "graph";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { openAlert } from "redux/actions";
import { displayErrorHandler } from "utils";

const useGetMember = (id) => {
    const { isAuthenticated } = useAuth0();

    const { t } = useTranslation();

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const {
        data,
        error,
        loading,
    } = useQuery(
        getMemberQuery,
        {
            onCompleted: ({ driveMember }) => {
                if (!driveMember) navigate(urlsData.routes.notFound);
            },
            skip: !isAuthenticated || !id,
            variables: {
                where: { id },
            },
        },
    );

    useEffect(
        () => {
            if (error?.message === constantsData.failedToFetch && !loading) {
                displayErrorHandler(
                    t("messages.networkFailure"),
                    dispatch,
                    openAlert,
                );
            }
        },
        [error, data], // eslint-disable-line
    );

    return {
        data,
        loading,
    };
};

export default useGetMember;
